import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";

// FIXME: Automatically disabled during ESLint config update
const syncWorkerWithZendeskRequestSchema = z.object({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  workerId: z.string(),
});

const syncWorkerWithZendeskResponseSchema = z.object({
  data: z.object({
    id: z.string(),
    type: z.literal("zendesk-sync"),
  }),
});

type SyncWorkerWithZendeskRequest = z.infer<typeof syncWorkerWithZendeskRequestSchema>;
type SyncWorkerWithZendeskResponse = z.infer<typeof syncWorkerWithZendeskResponseSchema>;

export function useSyncWorkerWithZendesk(
  options?: UseMutationOptions<SyncWorkerWithZendeskResponse, unknown, SyncWorkerWithZendeskRequest>
) {
  return useMutation({
    mutationFn: async (payload: SyncWorkerWithZendeskRequest) => {
      const { workerId } = payload;
      const response = await post({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/workers/${workerId}/zendesk-syncs`,
        responseSchema: syncWorkerWithZendeskResponseSchema,
      });
      return response.data;
    },
    ...options,
  });
}
